module.exports = __webpack_public_path__ + "img/pr-4.9d665bd2.png";